import React, { createContext, useContext, useState, useCallback } from 'react';

const SupportWidgetCtx = createContext(null);

export const SupportWidgetProvider = ({ children }) => {
  const [hidden, setHidden] = useState(false);
  const setSupportWidgetHidden = useCallback((value) => setHidden(value), []);
  return (
    <SupportWidgetCtx.Provider value={{ hidden, setSupportWidgetHidden }}>
      {children}
    </SupportWidgetCtx.Provider>
  );
};

// Used by full-screen overlays (e.g. the screenshot lightbox) to hide the
// Freshdesk chat bubble while open, since it floats on top of their UI.
export const useSetSupportWidgetHidden = () => {
  const ctx = useContext(SupportWidgetCtx);
  return ctx?.setSupportWidgetHidden ?? (() => {});
};

// Used by the Main layout to decide whether to render FreshdeskWebChat
export const useSupportWidgetHidden = () =>
  useContext(SupportWidgetCtx)?.hidden ?? false;
